module.exports = __webpack_public_path__ + "img/5.5370c9f8.jpg";